<template>
  <div class="w-full flex Lato justify-center h-screen">
    <div class="self-center flex flex-col p-2">
      <p class="font-semibold text-center text-2xl mb-5 text-purple_dark">Flora Admin Panel</p>
      <div class="shadow-2xl rounded bg-white" style="width:340px">
        <ValidationObserver ref="observe" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)" class="flex">
            <div class="w-2/3">

              <ValidationProvider rules="required" v-slot="{}">
                <input class="shadow w-full h-10 appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                       placeholder="Secret Word Please 🙄😅"
                       type="text"
                       v-model="word">
              </ValidationProvider>
            </div>
            <div class="flex items-center w-1/3 justify-between">
              <button class="bg-purple w-full h-full hover:bg-red-dark-700 text-white  py-2 px-4 rounded-r focus:outline-none"
                      type="submit">
                Login
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>

    </div>

  </div>
</template>

<script>
  // eslint-disable-next-line no-unused-vars
  import {db} from "../db";
  import {eventBus} from "../eventbus";

  export default {
    name: "Login",

    data: () => ({
      word: ''
    }),
    props: {
      secret: {
        type: Array
      }
    },
    created() {

    },
    methods: {
      onSubmit() {
        if (this.secret[0].value === this.word) {
          this.$toast.open({
            message: 'Welcome O',
            type: 'success'
          });
          eventBus.$emit('Main')
        } else {
          this.$toast.open({
            message: 'Something Went Wrong, Are you one of us?',
            type: 'error'
          });
        }
        // eslint-disable-next-line no-unused-vars

      },
    }
  }
</script>

<style scoped>

</style>